import { useGetCurrentTenantQuery } from 'store/api/tenants';
import { Setting } from 'types/back-office-settings';
import { useSettings } from 'utils/useSettings';

/**
 * The CURRENCY code a create form starts its currency field with: the firm's default while DEFAULT_CURRENCY is on for
 * the signed-in colleague, else null, as it is while the tenant loads and when it fails. A form that takes its
 * starting values once waits out `isLoading`, so a late code never resets what the user typed.
 */
export const useDefaultCurrencyCode = () => {
    const isOn = useSettings().isSettingEnabled(Setting.DEFAULT_CURRENCY);
    const { data: tenant, isLoading } = useGetCurrentTenantQuery(undefined, { skip: !isOn });
    return { code: (isOn && tenant?.defaultCurrencyTypeCode) || null, isLoading: isOn && isLoading };
};

/** The form's own option for the code: none for a code that is no longer a valid CURRENCY option. */
export const defaultCurrencyOption = <T extends { value: unknown }>(options: T[], code: string | null): T | null =>
    (code && options.find((option) => option.value === code)) || null;
